import { BaseChartAPI } from '../base-chart/base-chart-api.js';
class PieChartAPI extends BaseChartAPI {
    getCx() {
        return this.state.cx;
    }
    setCx(cx) {
        this.setState({ cx });
    }
    getCy() {
        return this.state.cy;
    }
    setCy(cy) {
        this.setState({ cy });
    }
    getDataKey() {
        return this.state.dataKey;
    }
    setDataKey(dataKey) {
        this.setState({ dataKey });
    }
    getEndAngle() {
        return this.state.endAngle;
    }
    setEndAngle(endAngle) {
        this.setState({ endAngle });
    }
    getLabelColor() {
        return this.state.labelColor;
    }
    setLabelColor(labelColor) {
        this.setState({ labelColor });
    }
    getLabelValuesAsPercentage() {
        return this.state.labelValuesAsPercentage;
    }
    setLabelValuesAsPercentage(labelValuesAsPercentage) {
        this.setState({ labelValuesAsPercentage });
    }
    getNameKey() {
        return this.state.nameKey;
    }
    setNameKey(nameKey) {
        this.setState({ nameKey });
    }
    getPaddingAngle() {
        return this.state.paddingAngle;
    }
    setPaddingAngle(paddingAngle) {
        this.setState({ paddingAngle });
    }
    getPiePiecesColors() {
        return this.state.piePiecesColors;
    }
    setPiePiecesColors(piePiecesColors) {
        this.setState({ piePiecesColors });
    }
    getShowLabelLines() {
        return this.state.showLabelLines;
    }
    setShowLabelLines(showLabelLines) {
        this.setState({ showLabelLines });
    }
    getStartAngle() {
        return this.state.startAngle;
    }
    setStartAngle(startAngle) {
        this.setState({ startAngle });
    }
}
export { PieChartAPI, };
//# sourceMappingURL=pie-chart-api.js.map